import { StyledBasicModalWithConfirmation } from '__pages/ActivitySettings/pages/ScheduledAndLogged/styled';
import { TeamsActivitiesWizard } from 'ts-components/RecordLayout/Wizard/TeamActivitiesWizard';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type EditColumnsModalProps = {
  fields: any[];
  isLoadingFields: boolean;
  isEditColumnsModalOpen: boolean;
  hideEditColumnsModal: () => void;
  columnSettings: any;
  isColumnSettingsLoading: boolean;
  defaultColumnSettings: any;
  queryKey: string[];
  updateColumnsConfig: (meta: any) => Promise<void>;
  showGroupedColumnEditor?: boolean;
  columnWidths: Record<string, number>;
};

export const EditColumnsModal = ({
  fields = [],
  isLoadingFields,
  isEditColumnsModalOpen,
  hideEditColumnsModal,
  columnSettings,
  isColumnSettingsLoading,
  defaultColumnSettings,
  updateColumnsConfig,
  showGroupedColumnEditor,
  columnWidths,
}: EditColumnsModalProps) => {
  const dirtyRef = useRef(false);
  const [values, setValues] = useState<null | { meta: any }>(null);

  const handleChangeMetadata = useCallback(
    (meta: any, dirty = true) => {
      setValues((prev) => ({ ...(prev as any), meta }));
      dirtyRef.current = dirty;
    },
    [setValues]
  );

  const handleEditColumnsModalSubmit = useCallback(async () => {
    await updateColumnsConfig({
      columns: values?.meta.columns.map((column: any) => ({
        ...column,
        width: columnWidths[column.id] || column.width,
      })),
    });
    hideEditColumnsModal();
    setValues(null);
    dirtyRef.current = false;
  }, [values, updateColumnsConfig, hideEditColumnsModal, columnWidths]);

  const { t } = useTranslation();

  const activityFields = useMemo(
    () => (showGroupedColumnEditor ? fields : []),
    [showGroupedColumnEditor, fields]
  );

  return (
    <StyledBasicModalWithConfirmation
      heading={t('Choose Columns to Display')}
      dirty={dirtyRef.current}
      size={'columns_editor'}
      buttonText={t('Save')}
      defaultLeftBtnText={t('Cancel')}
      typeOfContent="default"
      show={isEditColumnsModalOpen}
      onHide={hideEditColumnsModal}
      hasOneBtnSubmit
      onConfirm={handleEditColumnsModalSubmit}
    >
      <TeamsActivitiesWizard
        noStepNumber
        activityFields={activityFields}
        setMetadata={handleChangeMetadata}
        metadata={columnSettings}
        loading={isColumnSettingsLoading || isLoadingFields}
        defaultColumnSettingsPreset={defaultColumnSettings.columns}
        isEdit={true}
        disabledNameField={false}
        isGropedOptions={Boolean(activityFields.length)}
      />
    </StyledBasicModalWithConfirmation>
  );
};
